define('Responsive/util/dom',['require','exports','module','./string'],function(require,exports,module){
	var ReString = require( './string' );
	var BASE10=10;

	return {
	    removeNode : function(parent,child){

            if(child===undefined){
                child=parent;
                parent=child && child.parentNode;
            }
            if(parent && child && child.parentNode===parent){
                parent.removeChild(child);
                    // Return incase the caller would like to store the
                    // old child.
                return child;
            }

	    	return this;
	    },
	    removeStyleProperty : function(el,attr){
	    	if(el && el.style && attr){
	    	/* IE doesn't support remove property, so do this first */
	    		el.style[attr]='';
	    		el.style.removeProperty(attr);
	    	}
	    	return this;
	    },

	    computedHeight : function(view){
	    	return this.computed(view).height;
		},

	    computedWidth : function(view){
	    	return this.computed(view).width;
		},

		computed : (function(compute){
			var _height="height",
				_width="width";

		    return compute && function(el,prop){
		        return prop ? parseInt(compute(el,'').getPropertyValue(prop),BASE10) : {
			        height : parseInt(compute(el,'').getPropertyValue(_height),BASE10),
			        width  : parseInt(compute(el,'').getPropertyValue(_width),BASE10)
			    }

		    } || function(el,prop){
		        return prop ? el[prop] : {
			        height : el.offsetHeight,
			        width  : e.offsetWidth
			    }
		    };
		})(document.defaultView && document.defaultView.getComputedStyle),


		cssValAsNumber : function(cssVal) {
			if(isNaN(cssVal)) {
				if(cssVal==="auto" || cssVal==="inherit") {
					return 1;
				}

				if(cssVal.indexOf("%") > -1) {
					return 10000;
				}
				if(cssVal.toLowerCase().indexOf("px") !== -1) {
					return parseFloat(cssVal,BASE10);
				}

			}
			return cssVal;
		},
		createStyleNode : function(opts,node){
				var style=node||document.createElement('style'),
					css=opts.css||'';

			style.type=opts.type||"text/css";
			style.media=opts.media||"all";
			if(style.styleSheet){
				style.styleSheet.cssText=css;
			}else if(style.innerHTML){
				style.innerHTML=css;
			}else{
				style.appendChild(document.createTextNode(css))
			}
			return style;
		},
		
		isBoundByParent : function (_view) {
			var view= _view && _view.isViewLoaded() && _view.getView(),
		  		parent= view && _view.parentViewController && 
		  			_view.parentViewController.isViewLoaded() && _view.parentViewController.getView(),
		  		bounds, port, center;

		  if(!view){
		  	return false;
		  }
		  if(!!!parent && _view && view){
		  	return !!_view.rootView;
		  }

		  bounds=view.getBoundingClientRect();
		  port=parent.getBoundingClientRect();
		  center=(bounds.left + bounds.width/2);

		  return center > port.left && center < port.right;
		},
		scrollToTop :function(view,top){
			var op=window.scrollY;
			view.scrollIntoView(!top,0);
			return function(){
				window.scrollTo(op,0);
			}
		},
        setClassName : function(view, className, replace){
            var $view = $(view);
            if(className){
                $view.addClass(className);
            }
            if(replace){
                $view.removeClass(replace);
            }
            /*
            var classNames=view.className.split(keyword||className||' ');
            classNames.push(className);
            view.className=Re.util.ws(Re.util.trim(classNames.join(' ')));
             */
            // var classNames=(view.className||"").split(' '),
            //     len=classNames.length,
            //     found=false,
            //     _class,
            //     i=0;
            // //keyword=keyword || '';
            // for(;i<len;i++){
            //     _class=classNames[i];
            //     if(_class===replace || _class===className){
            //         classNames[i]= replace || className;
            //         found=true;
            //     }
            // }
            // if(!found){
            //     classNames.push(className);
            // }
            // view.className=ReString.ws(ReString.trim(classNames.join(' ')));
            return this;
        },
        removeClassName : function(view, className){
            if(className){
            	$(view).removeClass(className);
            }
        },
	}
});
